<template>
  <transition name="mask">
    <div v-if="show">
      <div :class="!isAuthorize ? 'login-modal' : 'login-modal is-authorize'">
        <div class="login-modal-img cursor-default">
          <h3 class="mt-3">微信{{ type || '登录' }}</h3>
        </div>
        <div v-if="!isAuthorize" class="text-center pt-3 pb-10">
          <Qrcode></Qrcode>
          <p class="mt-2 text-muted cursor-default">
            请使用微信扫描二维码{{ type || '登录' }}<br />
            “景德镇御窑厂”
          </p>
        </div>
        <div v-else class="login-modal-body">
          <form class="text-left w-full inline-block">
            <MobileCode
              ref="validInput"
              :value="show"
              @input="onMobileCodeInput"
            ></MobileCode>
          </form>
        </div>
      </div>
    </div>
  </transition>
</template>
<script>
import valid from '@/core/mixins/valid'
import MobileCode from '@/components/common/MobileCode'
import Qrcode from '@/components/wechat/Qrcode'

export default {
  name: 'login-bar',
  mixins: [valid],
  components: {
    MobileCode,
    Qrcode
  },
  props: {
    show: null,
    isAuthorize: null,
    type: null
  },
  data() {
    return {}
  },
  mounted() {},
  methods: {
    onMobileCodeInput(val) {
      this.$emit('update:show', val)
    }
  }
}
</script>
<style lang="scss" scoped>
@import '@/styles/css_base.scss';
.mask-enter-active,
.mask-leave-active {
  transition: opacity 0.35s;
  -moz-transition: opacity 0.35s;
  /* Firefox 4 */
  -webkit-transition: opacity 0.35s;
  /* Safari 和 Chrome */
  -o-transition: opacity 0.35s;
  /* Opera */
}

.mask-enter,
.mask-leave-to {
  opacity: 0;
}

.login-modal {
  width: 490px;
  margin: 0 auto;
  outline: 0;
  top: 50%;
  left: 50%;
  background-color: $c-transparent;
  color: $c-white;
  position: fixed;
  margin-top: -200px;
  margin-left: -245px;
  z-index: 1001;
}

// .login-modal-header {
//   padding: 0 20px;
//   width: 100%;
//   height: 58px;
//   line-height: 58px;
//   text-align: right;
//   overflow: hidden;
//   text-overflow: ellipsis;
//   vertical-align: middle;
//   white-space: nowrap;
// }

.login-modal-body {
  padding: 42px 50px 33px;
  text-align: center;
  .input-css {
    margin-bottom: 18px;
  }
  .input-full-btn {
    margin-top: 0;
    margin-bottom: 0;
  }
}
.login-modal-img {
  padding: 20px 20px 0px;
  text-align: center;
}

// .qr-code {
//   display: inline-block;
//   margin: 30px 0;
//   border: 1px solid $c-m-gray-light;
//   width: 220px;
//   height: 220px;
//   line-height: 218px;

//   img {
//     width: 94%;
//     height: 94%;
//   }
// }
// .register-css {
//   padding: 42px 0 33px !important;
// }
.text-muted {
  font-size: 16px;
}
.login-modal.is-authorize {
  background-color: $c-tour-0;

  .login-modal-img {
    display: none;
  }
  .login-modal-body {
    background-image: url('../../../static/images/public/bg-flower-g.png');
    background-repeat: no-repeat;
    background-size: auto 310px;
    background-position: 310px -30px;
  }
}
</style>
